import * as Yup from "yup";

export const getBrandValidationSchema = (
  isEditing = false,
  hasExistingImage = false,
) =>
  Yup.object({
    title: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
      .required("Brand title is required"),

    slug: Yup.string()
      .matches(
        /^[a-z0-9-]+$/,
        "Slug must contain lowercase letters, numbers and hyphens only",
      )
      .required("Slug is required"),

    description: Yup.string().nullable(),

    isActive: Yup.boolean(),

    image:
      isEditing && hasExistingImage
        ? Yup.mixed().nullable()
        : Yup.mixed().required("Brand image is required"),
  });

export const brandValidationSchema = getBrandValidationSchema();
